import Configuration from "@/legacy/configuration/config-provider";

export const BaseUrl = Configuration.value("backendHost");
export const BaseAssetsUrl = Configuration.value("assetsUrl");
export const Version = process.env.APP_VERSION || "0";
export const Iam = Configuration.value("iam");
export const validOcr = 75;
export const ProductionMode = process.env.VUE_APP_DEBUG === "false" || process.env.VUE_APP_DEBUG === undefined;
export const WatchAltHeader = Configuration.value("watchAltHeader");
